( function () {
	/*
 * Scripts and functions related to displaying background video on Webbdagarna
 */
	var $ = require('jquery');
	var i = 0;

	$('.hero--video').each( function( index ) {
		var player_id  = "#" + $(this).find('video').attr('id');
		var player_pause = $(this).find('.hero__video-play');
		var video = document.getElementById(player_id);
		i++;
	});

	$('video').on('click', function() {

		this.controls = false; //Hides default controls
		this[this.paused ? 'play' : 'pause']();
		var player_pause = $(this).parent().parent().find('.hero__video-play');
		 if ( this.paused ) {
			 player_pause.find('i').toggleClass('icon-pause icon-play-circled2');
		 } else {
			 player_pause.find('i').toggleClass('icon-pause icon-play-circled2');
		 }
	});
    // if (supportsVideo) {
	// 	var video = document.getElementById('video');
	// 	var videoControls = document.getElementById('video-controls');
	// //	video.controls = false; //Hides default controls
	// 	videoControls.style.display = 'block'; //Show custom controls
	// 	video.volume = 0.1;
	// 	var playpause = document.getElementById('play-pause-desktop');
	// 	var mute = document.getElementById('mute');
	//
	// 	playpause.addEventListener('click', function(e) {
	// 	    console.log('test');
	// 	    if (video.paused || video.ended ) {
	// 		video.play();
	// 		 $('#play-pause-desktop i').toggleClass('fa-stop-circle-o').toggleClass('fa-play-circle-o');
	// 	} else {
	// 	;
	// 		video.pause();
	// 		 $('#play-pause-desktop i').toggleClass('fa-stop-circle-o').toggleClass('fa-play-circle-o');
	// 	    }
	// 	 });
	//
	// 	 mute.addEventListener('click', function(e) {
	// 	    video.muted = !video.muted;
	// 	     $('#mute i').toggleClass('fa-volume-off').toggleClass('fa-volume-up');
	// 	 });
	//
    // }
})();
